import { render, staticRenderFns } from "./ListModule.vue?vue&type=template&id=6200a5e0&scoped=true&"
import script from "./ListModule.vue?vue&type=script&lang=js&"
export * from "./ListModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6200a5e0",
  null
  
)

export default component.exports